module.exports = __webpack_public_path__ + "img/01-เข้าสู่ระบบ.8530c73a.png";